<template>
  <div >
    <b-overlay id="container-material">
      <div class="row">
        <div class="col-12">
          <b-card id="Materiales">
            <div class="row col-12"
                 slot="header"
            >
              <h3>Materiales</h3>
              <div class="col-md-1 my-auto" hidden>
                <b-form-checkbox
                  v-model="viewMaterials"
                  name="check-button"
                  switch
                />
              </div>
              <div style="right: 1px; position: absolute">
                <b-button
                  pill
                  variant="primary"
                  size="sm"
                  @click="addMaterial"
                >
                  <b-icon icon="plus-circle-fill"></b-icon>
                  Agregar Material
                </b-button>
              </div>
            </div>
            <PopUpAddMaterials
              @reload="searchListMaterial"
              :whoCall="whoCall"
              :arrayMaterial="arrayMaterial"
            />
            <form
              autocomplete="off"
              data-vv-scope="search-material"
              @submit.prevent
            >
              <div class="row">
                <div class="col-md-4">
                  <label>Buscar coincidencias Nombre Material</label>
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-icon
                        style="cursor:pointer;"
                        icon="search"
                        @click="searchListMaterial"
                      ></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="textSearch"
                      @keyup.enter="searchListMaterial"
                    />
                  </b-input-group>
                </div>
                <div class="col-md-3 ">
                  <label>Categoría</label>
                  <select
                    type="select"
                    class="form-control"
                    v-model="categoryMaterial"
                  >
                    <option
                      selected
                      v-bind:value="{value: 0, text: ''}"
                    ></option>
                    <option
                      v-for="option in listCategorys"
                      v-bind:value="{ value: option.categoryId, text: option.categoryName}"
                      v-bind:key="option.categoryId"
                    >
                      {{ option.categoryName }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 ">
                  <label>Marca</label>
                  <select
                    type="select"
                    class="form-control"
                    v-model="brandMaterial"
                  >
                    <option
                      selected
                      v-bind:value="{value: 0, text: ''}"
                    ></option>
                    <option
                      v-for="option in listBrands"
                      v-bind:value="{value: option.brandId, text: option.brandName}"
                      v-bind:key="option.brandId"
                    >
                      {{ option.brandName }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2 align-self-end">
                  <vs-chip
                    style="cursor:pointer;"
                    @click.native="searchListMaterial"
                  >
                    <vs-avatar icon="search" color="primary" />
                    <strong>Buscar</strong>
                  </vs-chip>
                </div>
              </div>
            </form>
            <div class="row col-12 mt-4">
              <b-table
                class="w-100"
                hover
                :fields="fieldMat"
                :items="listMaterials"
                ref="tableMaterial"
              >
                <template  #cell(categoryMaterial)="row">
                  {{ row.item.categoryMaterial.descripcion }}
                </template>
                <template  #cell(brandMaterial)="row">
                  {{ row.item.brandMaterial.descripcion }}
                </template>
                <template #cell(priceMaterial)="row">
                  {{ parseInt(row.item.priceMaterial) | toCurrency }}
                </template>
                <template #cell(stateMaterial)="row">
                  <vs-chip
                    v-if="row.item.stateMaterial === materialState.ACTIVE"
                    title="Activo"
                  >
                    <vs-avatar icon="thumb_up" color="#26bd6a" />
                    Activo
                  </vs-chip>
                  <vs-chip
                    v-if="row.item.stateMaterial === materialState.INACTIVE"
                    title="Inactivo"
                  >
                    <vs-avatar icon="do_not_disturb" color="#DB1D2A" />
                    Inactivo
                  </vs-chip>
                </template>
                <template #cell(actions)="row">
                  <div v-tooltip="'Desplegar acciones'">
                    <b-dropdown
                      v-has-permission="'ED096'"
                      variant="link"
                      no-caret
                      right
                    >
                      <template #button-content>
                        <feather-icon
                          width="24px"
                          height="24px"
                          icon="SettingsIcon"
                          class="align-middle text-body"
                        />
                      </template>
                      <b-dropdown-item
                        @click="editMaterial(row.item.idMaterial,materialState.ACTIVE)"
                        data-cy="edit-info"
                      >
                        <vs-icon icon="edit"/>
                        Editar
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="showModalEditMaterialServices(row.item)"
                        data-cy="edit-services"
                      >
                        <vs-icon icon="content_paste"/>
                        Servicios
                      </b-dropdown-item>
                      <div>
                        <b-dropdown-item
                          v-if="row.item.stateMaterial === materialState.ACTIVE"
                          @click="chageStateMaterial(row.item.idMaterial)"
                          data-cy="deactivate"
                        >
                          <vs-icon icon="clear"/>
                          Desactivar
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-else
                          @click="chageStateMaterial(row.item.idMaterial)"
                          data-cy="activate"
                        >
                          <vs-icon icon="check"/>
                          Activar
                        </b-dropdown-item>
                      </div>
                    </b-dropdown>
                    <span />
                  </div>
                </template>
              </b-table>
            </div>
          </b-card>
        </div>
        <div class="row col-12">
          <div class="col-lg-4">
            <div class="mt-5">
              Mostrando
              <select
                v-model="rowspp"
                @change="searchListMaterial()"
              >
                <option value="10" selected="selected">10</option>
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="50">50</option>
              </select> registros por página.
            </div>
          </div>
          <div class="col-lg-8">
            <MaterialPagination
              :show="listMaterials.length"
              v-model="page"
            />
          </div>
        </div>
      </div>
        <b-modal
          size="lg"
          :ref="`material-edit-services`"
          hide-footer
          no-close-on-backdrop
          :title="`Editar servicios de material ${selectedMaterial.nameMaterial}`"
        >
          <materials-services-maintenance
            :material="selectedMaterial"
            @edited="handleOnServiceEdit"
          />
        </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import PopUpAddMaterials from '@/febos/global/materialsRequests/vistas/modals/PopUpAddMaterials';
import MaterialPagination from '@/febos/global/materialsRequests/components/MaterialPagination';
import MaterialProcessState from '@/febos/global/materialsRequests/mixins/MaterialProcessState';
import MaterialsServicesMaintenance from '@/febos/global/materialsRequests/components/MaterialsServicesMaintenance';

export default {
  name: 'MaterialsMaintenance',
  components: {
    PopUpAddMaterials,
    MaterialPagination,
    MaterialsServicesMaintenance
  },
  data() {
    return {
      viewMaterials: '',
      textSearch: '',
      rangePrice: {
        From: 0,
        To: 0
      },
      categoryMaterial: null,
      brandMaterial: null,
      rowspp: Number.parseInt(this.$route.query.paginate || 10, 10),
      page: Number.parseInt(this.$route.query.page || 1, 10),
      arrayMaterial: {
        categoryMaterial: {
          opcionId: null,
          descripcion: null
        },
        brandMaterial: {
          opcionId: null,
          descripcion: null
        },
        nameMaterial: null,
        priceMaterial: null,
        skuMaterial: null,
        imageMaterial: null,
        currencyMaterial: 'CLP'
      },
      materialState: MaterialProcessState,
      fieldMat: [
        { key: 'skuMaterial', label: 'SKU' },
        { key: 'nameMaterial', label: 'Nombre Material' },
        { key: 'brandMaterial', label: 'Marca' },
        { key: 'categoryMaterial', label: 'Categoría' },
        { key: 'priceMaterial', label: 'Precio Unitario' },
        { key: 'stateMaterial', label: 'Estado' },
        { key: 'actions', label: '' }
      ],
      arrayFilter: [],
      whoCall: '',
      selectedMaterial: []
    };
  },
  mounted() {
    this.loadCategoryBrand();
  },
  watch: {
    async page() {
      await this.searchListMaterial();
    },
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#container-material > .con-vs-loading');
        return;
      }
      this.$vs.loading({
        container: '#container-material',
        scale: 0.6
      });
    },
  },
  computed: {
    ...mapGetters('Materials', [
      'loading',
      'listMaterials',
      'fieldMaterial',
      'listCategorys',
      'listBrands'
    ])
  },
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'closeModal'
    ]),
    ...mapActions('Materials', [
      'loadListMaterial',
      'loadListCategory',
      'loadListBrand',
      'editMaterial'
    ]),
    loadCategoryBrand() {
      this.searchListMaterial();
      this.loadListCategory();
      this.loadListBrand();
    },
    addMaterial() {
      this.whoCall = 'new';
      this.arrayMaterial = {
        categoryMaterial: null,
        brandMaterial: null,
        nameMaterial: null,
        priceMaterial: null,
        skuMaterial: null,
        imageMaterial: null,
        currencyMaterial: 'CLP',
        stateMaterial: null
      };
      this.showModals('PopUpAddMaterials');
    },
    editMaterial(index) {
      const material = this.listMaterials.find((e) => e.idMaterial === index);
      if (material) {
        this.whoCall = 'edit';
        this.arrayMaterial = {
          idMaterial: index,
          categoryMaterial: [{
            opcionId: material.categoryMaterial.opcionId,
            descripcion: material.categoryMaterial.descripcion
          }],
          brandMaterial: {
            opcionId: material.brandMaterial.opcionId,
            descripcion: material.brandMaterial.descripcion
          },
          nameMaterial: material.nameMaterial,
          priceMaterial: material.priceMaterial,
          skuMaterial: material.skuMaterial,
          imageMaterial: '',
          currencyMaterial: 'CLP',
          estado: material.stateMaterial,
          materialServices: material.materialServices
        };
      }
      this.showModals('PopUpAddMaterials');
    },
    async chageStateMaterial(index) {
      const material = this.listMaterials.find((e) => e.idMaterial === index);
      if (material) {
        const state = material.stateMaterial === this.materialState.ACTIVE
          ? this.materialState.INACTIVE : this.materialState.ACTIVE;
        const editMaterial = {
          id: material.idMaterial,
          query: {
            marca: {
              opcionId: material.brandMaterial.opcionId,
              descripcion: material.brandMaterial.descripcion
            },
            categorias: [
              {
                opcionId: material.categoryMaterial.opcionId,
                descripcion: material.categoryMaterial.descripcion
              }
            ],
            precio: Number.parseInt(material.priceMaterial, 10),
            moneda: 'CLP',
            nombre: material.nameMaterial,
            SKU: material.skuMaterial,
            estado: state,
            servicios: material.materialServices
          }
        };
        await this.editMaterial(editMaterial);
        this.searchListMaterial();
      }
    },
    notify(message) {
      this.$bvToast.toast(
        message,
        {
          title: '¡Oops!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
    },
    validateRangePrice() {
      if (this.rangePrice.From > this.rangePrice.To) {
        this.notify('Precio desde no puede ser mayor a Precio Hasta');
        return false;
      }
      if (this.rangePrice.From < 0 || this.rangePrice.To < 0) {
        this.notify('Precio desde o hasta no pueden ser negativos');
        return false;
      }
      if (this.rangePrice.From > 9999999 || this.rangePrice.To > 9999999) {
        this.notify('Precio desde o hasta no pueden ser mayor a 9999999');
        return false;
      }
      if (this.rangePrice.From === '' || this.rangePrice.To === '') {
        this.rangePrice.From = 0;
        this.rangePrice.To = 0;
        return true;
      }
      return true;
    },
    async searchListMaterial() {
      if (!this.validateRangePrice()) return;
      const filterContent = this.setArrayFilter();
      const query = {
        params: {
          tipo: 'productos',
          campos: '*',
          pagina: this.page,
          orden: 'SKU',
          itemsPorPagina: this.rowspp,
          filtros: filterContent !== '' ? filterContent : ''
        }
      };
      await this.loadListMaterial(query);
    },
    setArrayFilter() {
      this.arrayFilter = [];
      if (this.textSearch) {
        this.arrayFilter.push({
          campo: 'nombre',
          valor: this.textSearch.toLowerCase()
        });
      }
      if (this.categoryMaterial !== null && this.categoryMaterial.value !== 0) {
        this.arrayFilter.push({
          campo: 'categorias.opcionId',
          valor: this.categoryMaterial.value
        });
      }
      if (this.brandMaterial !== null && this.brandMaterial.value !== 0) {
        this.arrayFilter.push({
          campo: 'marca.opcionId',
          valor: this.brandMaterial.value
        });
      }
      if (this.rangePrice.To > 0) {
        this.arrayFilter.push({
          campo: 'precio',
          valor: `${this.rangePrice.From}--${this.rangePrice.To}`
        });
      }
      const filter = [];
      this.arrayFilter.forEach((item) => {
        if (item.campo === 'nombre') filter.push(`${ item.campo }$${ item.valor }`);
        else filter.push(`${ item.campo }:${ item.valor }`);
      });
      return filter.join('|');
    },
    async showModalEditMaterialServices(item) {
      const material = this.listMaterials.find((e) => e.idMaterial === item.idMaterial);
      this.selectedMaterial = {
        ...item,
        state: material.stateMaterial
      };
      this.$refs['material-edit-services'].show();
    },
    handleOnServiceEdit() {
      this.loadCategoryBrand();
      this.$refs['material-edit-services'].hide();
    }
  }
};
</script>
